import type { CinemaContactApi, CinemaContactDetails, ContactDepartment, CinemaRequisites } from "../data/cinemaContacts.types"

export function mapCinemaContactApi(raw: CinemaContactApi | null | undefined): CinemaContactDetails | null {
    if (!raw || typeof raw !== "object") return null

    const departments: ContactDepartment[] = Array.isArray(raw.departments)
        ? raw.departments
              .filter((d): d is NonNullable<CinemaContactApi["departments"]>[number] => Boolean(d && typeof d.title === "string" && d.title.trim() !== ""))
              .map(d => ({
                  title: String(d.title).trim(),
                  contactPerson: (d.contact_person || d.contactPerson || undefined) || undefined,
                  phones: Array.isArray(d.phones) ? d.phones.map(String).filter(Boolean) : undefined,
                  emails: Array.isArray(d.emails) ? d.emails.map(String).filter(Boolean) : undefined,
              }))
        : []

    let requisites: CinemaRequisites | null = null
    if (raw.requisites && typeof raw.requisites === "object") {
        const r = raw.requisites
        requisites = {
            name: String(r.name ?? ""),
            inn: String(r.inn ?? ""),
            kpp: String(r.kpp ?? ""),
            ogrn: String(r.ogrn ?? ""),
            actualAddress: String(r.actual_address ?? ""),
            legalAddress: String(r.legal_address ?? ""),
            bankAccount: String(r.bank_account ?? ""),
            corrAccount: String(r.corr_account ?? ""),
            bik: String(r.bik ?? ""),
        }
        if (!requisites.name && !requisites.inn) {
            requisites = null
        }
    }

    return {
        cinemaId: Number(raw.cinema_id) || 0,
        seoName: String(raw.seo_name ?? ""),
        sessionsPhone: raw.sessions_phone ? String(raw.sessions_phone) : null,
        email: raw.email ? String(raw.email) : null,
        schedule: raw.schedule ? String(raw.schedule) : null,
        address: raw.address ? String(raw.address) : null,
        latitude: raw.latitude != null && raw.latitude !== "" ? String(raw.latitude) : null,
        longitude: raw.longitude != null && raw.longitude !== "" ? String(raw.longitude) : null,
        workTimes: Array.isArray(raw.work_times)
            ? raw.work_times.map((w: NonNullable<CinemaContactApi["work_times"]>[number]) => ({
                  dayWeek: Number(w.day_week),
                  timeStart: w.time_start ?? null,
                  timeEnd: w.time_end ?? null,
                  isClosed: Boolean(w.is_closed),
              }))
            : [],
        social: {
            vk: raw.social?.vk ? String(raw.social.vk) : null,
            max: raw.social?.max ? String(raw.social.max) : null,
        },
        linkToComment: raw.link_to_comment ? String(raw.link_to_comment) : null,
        departments,
        requisites,
    }
}
